module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/006-tanzania-3a8730b8a48c47bd4e3ab5c37f6cb1d5.svg";